import React, { useState } from "react";
import Table from "../../../../core/pagination/datatable";
import { Link } from "react-router-dom";
import { Button, Input, Switch, Space } from "antd";
import Swal from "sweetalert2";

const InspectionChecklist = () => {
  const [editingRow, setEditingRow] = useState(null);
  const [editedValue, setEditedValue] = useState("");

  const [data, setData] = useState([
    { id: 1, question: "Is the filter properly installed?", active: true },
    { id: 2, question: "Is the filter visibly clean?", active: true },
    { id: 3, question: "Is airflow unobstructed?", active: false },
  ]);

  // ----- Edit Submit -----
  const handleSubmit = (record) => {
    setData((prev) =>
      prev.map((item) =>
        item.id === record.id ? { ...item, question: editedValue } : item
      )
    );
    setEditingRow(null);
    setEditedValue("");
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This question will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setData((prev) => prev.filter((item) => item.id !== id));

        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The question has been removed.",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    });
  };

  const handleToggle = (checked, record) => {
    setData((prev) =>
      prev.map((item) =>
        item.id === record.id ? { ...item, active: checked } : item
      )
    );
    Swal.fire({
      icon: checked ? "success" : "warning",
      title: checked ? "Question Enabled" : "Question Disabled",
      text: `${record.question} is now ${checked ? "Active" : "Inactive"}`,
      timer: 1500,
      showConfirmButton: false,
    });
  };

  const columns = [
    {
      title: "Question",
      dataIndex: "question",
      key: "question",
      render: (_, record) => {
        if (editingRow === record.id) {
          return (
            <Space>
              <Input
                style={{ width: 280 }}
                defaultValue={record.question}
                onChange={(e) => setEditedValue(e.target.value)}
              />
              <Button
                type="primary"
                size="small"
                onClick={() => handleSubmit(record)}
              >
                Submit
              </Button>
              <Button size="small" onClick={() => setEditingRow(null)}>
                Cancel
              </Button>
            </Space>
          );
        }
        return <span>{record.question}</span>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <Button
            size="small"
            onClick={() => {
              setEditingRow(record.id);
              setEditedValue(record.question);
            }}
          >
            Edit
          </Button>

          <Switch
            checked={record.active}
            onChange={(checked) => handleToggle(checked, record)}
          />

          <Button
            danger
            size="small"
            onClick={() => {
              handleDelete(record.id);
            }}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    RFID List
                  </h4>
                </ol>
              </nav>
              <h6>Manage Printers</h6>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
              <div className="search-set mt-4"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                {/* {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : printerData?.length > 0 ? (
                  <Table
                    columns={columns}
                    dataSource={printerData}
                    rowKey="id"
                  />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )} */}

                <Table columns={columns} dataSource={data} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InspectionChecklist;
